import React from 'react';
import CalendarContent from 'src/components/CalendarContent/CalendarContent';
import CalendarHeader from 'src/components/CalendarHeader/CalendarHeader';
import {
  useCalendarViewOrchestrator,
  IUseCalendarViewOrchestratorReturn,
} from 'src/pages/Calendar/CustomHooks/useCalendarViewOrchestrator';
import 'react-datepicker/dist/react-datepicker.css';
import './Calendar.scss';

export const CalendarView = () => {
  const {
    fromDate,
    toDate,
    updateFromDate,
    updateToDate,
    goToToday,
    isTodaySelected,
    minDate,
    maxDate,
    defaultDate,
    events,
    eventTypes,
    properties,
    isLoading,
    error,
  }: IUseCalendarViewOrchestratorReturn = useCalendarViewOrchestrator();

  return (
    <div className="calendar-view">
      <CalendarHeader
        fromDate={fromDate}
        toDate={toDate}
        onFromDateChange={updateFromDate}
        onToDateChange={updateToDate}
        isTodaySelected={isTodaySelected}
        onGoToToday={goToToday}
        error={error}
      />
      <CalendarContent
        uniqueEventTypes={eventTypes}
        allPropertiesWithStates={properties}
        loading={isLoading}
        events={events}
        minDate={minDate}
        maxDate={maxDate}
        defaultDate={defaultDate}
        onSelectEvent={null}
      />
    </div>
  );
};

export default CalendarView;